// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BecomeACompany-page-ujGUK {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --green: #16a34a;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.BecomeACompany-wrap-gdxli {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
}

/* HERO */

.BecomeACompany-hero-UvP86 {
  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),
    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;
  padding: 56px 0 36px;
  text-align: center;
}

.BecomeACompany-eyebrow-LhNbC {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 14px;
}

.BecomeACompany-h1-Y8qtU {
  font-size: clamp(30px, 5vw, 48px);
  line-height: 1.06;
  font-weight: 800;
  margin: 0 auto 14px;
  max-width: 720px;
}

.BecomeACompany-hl-vMVk8 { color: var(--red); }

.BecomeACompany-sub-N1X4P {
  font-size: clamp(15px, 2.2vw, 18px);
  color: var(--muted);
  max-width: 620px;
  margin: 0 auto;
  line-height: 1.55;
}

/* BODY */

.BecomeACompany-body-kG_YE {
  padding: 8px 0 72px;
  background: #fff;
}

.BecomeACompany-loading-KGFxz {
  padding: 64px 0;
  text-align: center;
  color: var(--muted);
  font-weight: 600;
}

/* STATUS TRACKER */

.BecomeACompany-tracker-Pcccj {
  margin: 0 0 28px;
  padding: 18px 22px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: var(--bg);
}

.BecomeACompany-trackerInner-GkQ3P {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 6px;
}

.BecomeACompany-tNode-_bZeu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 9px;
  color: var(--muted);
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
}

.BecomeACompany-tDot-ZJcNt {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #fff;
  border: 2px solid var(--line);
  color: var(--muted);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 13px;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.BecomeACompany-tBar-ZLa1O {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  height: 2px;
  background: var(--line);
  margin: 0 4px;
}

.BecomeACompany-tActive-QZtHW { color: var(--ink); }

.BecomeACompany-tActive-QZtHW .BecomeACompany-tDot-ZJcNt {
  border-color: var(--red);
  color: var(--red);
  -webkit-box-shadow: 0 0 0 4px #fde7e8;
          box-shadow: 0 0 0 4px #fde7e8;
}

.BecomeACompany-tDone-Zf2mT { color: var(--ink); }

.BecomeACompany-tDone-Zf2mT .BecomeACompany-tDot-ZJcNt {
  background: var(--green);
  border-color: var(--green);
  color: #fff;
}

.BecomeACompany-tReject-wscBy {
  margin-top: 14px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fde7e8;
  color: var(--red-d);
  font-size: 14px;
  font-weight: 600;
}

/* LAYOUT — left step nav + panel */

.BecomeACompany-layout-gW78q {
  display: grid;
  grid-template-columns: 232px 1fr;
  gap: 28px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
}

.BecomeACompany-nav-WLMTI {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 6px;
  position: sticky;
  top: 20px;
}

.BecomeACompany-navItem-D66HW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  text-align: left;
  padding: 13px 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  color: var(--muted);
  -webkit-transition: border-color 0.16s, color 0.16s, background 0.16s;
  transition: border-color 0.16s, color 0.16s, background 0.16s;
}

.BecomeACompany-navItem-D66HW:hover { border-color: #f3c9cb; }

.BecomeACompany-navActive-R99DQ {
  border-color: var(--red);
  color: var(--ink);
  background: #fff5f5;
}

.BecomeACompany-navDone-hSQaI { color: var(--ink); }

.BecomeACompany-navNo-Y0Kgu {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: var(--bg);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 13px;
  font-weight: 800;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.BecomeACompany-navActive-R99DQ .BecomeACompany-navNo-Y0Kgu { background: var(--red); color: #fff; }

.BecomeACompany-navDone-hSQaI .BecomeACompany-navNo-Y0Kgu { background: var(--green); color: #fff; }

.BecomeACompany-navLabel-MIkQS { -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; }

/* PANEL */

.BecomeACompany-panel-SsBFD {
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 30px 32px;
  background: #fff;
  -webkit-box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);
          box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);
}

.BecomeACompany-stepTitle-jElV5 {
  font-size: 24px;
  font-weight: 800;
  margin: 0 0 6px;
}

.BecomeACompany-stepHint-gGMZg {
  font-size: 15px;
  color: var(--muted);
  line-height: 1.55;
  margin: 0 0 22px;
}

/* ALERTS */

.BecomeACompany-alertErr-MAZlS {
  padding: 11px 14px;
  border-radius: 10px;
  background: #fde7e8;
  color: var(--red-d);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
}

.BecomeACompany-alertOk-rKEvF {
  padding: 11px 14px;
  border-radius: 10px;
  background: #e7f6ec;
  color: #137a37;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
}

/* FORM */

.BecomeACompany-formGrid-IVMwV {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 6px;
}

.BecomeACompany-field-n77dm { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; }

.BecomeACompany-fieldFull-lV3w8 { grid-column: 1 / -1; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; }

.BecomeACompany-field-n77dm > span,
.BecomeACompany-fieldFull-lV3w8 > span {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 6px;
}

.BecomeACompany-input-KhdGO {
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 11px 13px;
  border: 1px solid var(--line);
  border-radius: 10px;
  font-family: inherit;
  font-size: 15px;
  color: var(--ink);
  background: #fff;
  -webkit-transition: border-color 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, box-shadow 0.16s;
  transition: border-color 0.16s, box-shadow 0.16s, -webkit-box-shadow 0.16s;
}

.BecomeACompany-input-KhdGO:focus {
  outline: none;
  border-color: var(--red);
  -webkit-box-shadow: 0 0 0 3px #fde7e8;
          box-shadow: 0 0 0 3px #fde7e8;
}

/* SUB-BLOCKS */

.BecomeACompany-subBlock-EdUxN {
  margin: 26px 0 8px;
  padding-top: 22px;
  border-top: 1px solid var(--line);
}

.BecomeACompany-subTitle-K41mr {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 14px;
}

.BecomeACompany-empty-mEKda {
  font-size: 14px;
  color: var(--muted);
  margin: 0 0 12px;
}

/* CHIPS */

.BecomeACompany-chips-jVEAi {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 9px;
  margin-bottom: 8px;
}

.BecomeACompany-chip-mZO_P,
.BecomeACompany-chipSm-sMHii {
  padding: 9px 15px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  color: var(--muted);
  cursor: pointer;
  -webkit-transition: all 0.14s;
  transition: all 0.14s;
}

.BecomeACompany-chipSm-sMHii {
  padding: 6px 11px;
  font-size: 12.5px;
  min-width: 42px;
  text-align: center;
}

.BecomeACompany-chip-mZO_P:hover,
.BecomeACompany-chipSm-sMHii:hover { border-color: #f3c9cb; }

.BecomeACompany-chipOn-OHYHW {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}

/* DOC ROWS */

.BecomeACompany-docRow-Ovkuv {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
  margin-bottom: 10px;
  font-size: 14px;
}

.BecomeACompany-tag-dKCfI {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  padding: 4px 9px;
  border-radius: 999px;
  background: #fff3d6;
  color: #946200;
  white-space: nowrap;
}

.BecomeACompany-tagOk-GqaUi { background: #e7f6ec; color: #137a37; }

/* CONNECT CARD */

.BecomeACompany-connectCard-ChkPr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 22px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: var(--bg);
  margin-bottom: 18px;
}

.BecomeACompany-connectIc-rzNXP {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.BecomeACompany-connectIc-rzNXP svg { width: 28px; height: 28px; }

.BecomeACompany-connectBody-u1Rxy h3 { margin: 0 0 4px; font-size: 17px; font-weight: 800; }

.BecomeACompany-connectBody-u1Rxy p { margin: 0; font-size: 14px; color: var(--muted); line-height: 1.5; }

/* REVIEW */

.BecomeACompany-review-FPOvH {
  display: grid;
  gap: 16px;
  margin-bottom: 8px;
}

.BecomeACompany-reviewSec-g2_LR {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 18px 20px;
}

.BecomeACompany-reviewSec-g2_LR h3 { margin: 0 0 12px; font-size: 16px; font-weight: 800; }

.BecomeACompany-dl-Yi1r4 {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 8px 16px;
  margin: 0;
  font-size: 14px;
}

.BecomeACompany-dl-Yi1r4 dt { color: var(--muted); font-weight: 700; }

.BecomeACompany-dl-Yi1r4 dd { margin: 0; color: var(--ink); }

/* ACTIONS */

.BecomeACompany-actions-en6vc {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  margin-top: 26px;
  padding-top: 22px;
  border-top: 1px solid var(--line);
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.BecomeACompany-btn-AY5EW {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  background: var(--red);
  color: #fff;
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, transform 0.16s, box-shadow 0.16s;
  transition: background 0.16s, transform 0.16s, box-shadow 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.BecomeACompany-btn-AY5EW:hover:not(:disabled) {
  background: var(--red-d);
  -webkit-transform: translateY(-1px);
      -ms-transform: translateY(-1px);
          transform: translateY(-1px);
  -webkit-box-shadow: 0 12px 26px rgba(232, 35, 43, 0.25);
          box-shadow: 0 12px 26px rgba(232, 35, 43, 0.25);
}

.BecomeACompany-btnGhost-zQGzl {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--ink);
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  -webkit-transition: border-color 0.16s;
  transition: border-color 0.16s;
}

.BecomeACompany-btnGhost-zQGzl:hover:not(:disabled) { border-color: var(--red); color: var(--red); }

.BecomeACompany-btnText-CpvwE {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  color: var(--muted);
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  padding: 8px;
}

.BecomeACompany-btn-AY5EW:disabled,
.BecomeACompany-btnGhost-zQGzl:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* LOGO ROW */

.BecomeACompany-logoRow-kyA5j {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 18px;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
  margin: 6px 0 22px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.BecomeACompany-logoPreview-CYzJw {
  width: 96px;
  height: 96px;
  border-radius: 18px;
  border: 1px solid var(--line);
  background: var(--bg);
  color: var(--muted);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  overflow: hidden;
}

.BecomeACompany-logoPreview-CYzJw svg { width: 38px; height: 38px; }

.BecomeACompany-logoImg-KgNYJ { width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; }

.BecomeACompany-logoUploadCell-DdqOV { -webkit-box-flex: 1; -ms-flex: 1 1 260px; flex: 1 1 260px; min-width: 240px; }

/* UPLOAD DROP-ZONE */

.BecomeACompany-upload-oGymY { margin: 12px 0 4px; }

.BecomeACompany-uploadHead-k92EJ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.BecomeACompany-uploadLabel-wg0ws { font-size: 13px; font-weight: 700; color: var(--ink); }

.BecomeACompany-uploadReq-SwMGO {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--red);
  background: #fde7e8;
  border-radius: 999px;
  padding: 2px 8px;
}

.BecomeACompany-uploadHint-jEpjP { margin: 0 0 8px; font-size: 13px; color: var(--muted); line-height: 1.5; }

.BecomeACompany-uploadDrop-pR_Ka {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 14px 16px;
  border: 1.5px dashed var(--line);
  border-radius: 12px;
  background: var(--bg);
  cursor: pointer;
  -webkit-transition: border-color 0.16s, background 0.16s;
  transition: border-color 0.16s, background 0.16s;
}

.BecomeACompany-uploadDrop-pR_Ka:hover { border-color: #f3c9cb; background: #fff5f5; }

.BecomeACompany-uploadDrop-pR_Ka svg { width: 22px; height: 22px; color: var(--red); -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; }

.BecomeACompany-uploadDropText-_GBS8 {
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.BecomeACompany-uploadDropDone-o1IdE {
  border-style: solid;
  border-color: var(--green);
  background: #e7f6ec;
}

.BecomeACompany-uploadDropDone-o1IdE svg { color: var(--green); }

.BecomeACompany-uploadDropDone-o1IdE .BecomeACompany-uploadDropText-_GBS8 { color: #137a37; }

.BecomeACompany-uploadInput-HxGp3 {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.BecomeACompany-uploadOk-NMdLo {
  display: inline-block;
  margin-top: 7px;
  font-size: 12.5px;
  font-weight: 700;
  color: #137a37;
}

.BecomeACompany-uploadErr-oFS94 {
  display: inline-block;
  margin-top: 7px;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--red-d);
}

/* SERVICE-AREA MODE CARDS */

.BecomeACompany-modeGrid-msdK_ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.BecomeACompany-modeCard-AYhYr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  text-align: left;
  gap: 4px;
  padding: 16px;
  border: 1.5px solid var(--line);
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  -webkit-transition: border-color 0.16s, background 0.16s;
  transition: border-color 0.16s, background 0.16s;
}

.BecomeACompany-modeCard-AYhYr:hover { border-color: #f3c9cb; }

.BecomeACompany-modeCardOn-QoP1e { border-color: var(--red); background: #fff5f5; }

.BecomeACompany-modeRadio-mSpEJ {
  color: var(--red);
  font-size: 14px;
  line-height: 1;
  height: 14px;
  margin-bottom: 2px;
}

.BecomeACompany-modeTitle-E8zla { font-size: 14.5px; font-weight: 800; color: var(--ink); }

.BecomeACompany-modeDesc-XHbBF { font-size: 12.5px; color: var(--muted); line-height: 1.45; }

/* TIGHTER SUB-BLOCK (no top border / divider) */

.BecomeACompany-subBlockTight-tsZHp { margin-top: 16px; }

.BecomeACompany-miniLabel-AdRMw {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 8px;
}

@media (max-width: 620px) {
  .BecomeACompany-modeGrid-msdK_ { grid-template-columns: 1fr; }
}

@media (max-width: 860px) {
  .BecomeACompany-layout-gW78q { grid-template-columns: 1fr; }
  .BecomeACompany-nav-WLMTI {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    overflow-x: auto;
    position: static;
  }
  .BecomeACompany-navItem-D66HW { white-space: nowrap; }
}

@media (max-width: 620px) {
  .BecomeACompany-formGrid-IVMwV { grid-template-columns: 1fr; }
  .BecomeACompany-dl-Yi1r4 { grid-template-columns: 110px 1fr; }
  .BecomeACompany-panel-SsBFD { padding: 22px 18px; }
  .BecomeACompany-tLabel-UKxcO { display: none; }
}

/* ---- In-app HYBRID payout: success + hosted-fallback states ---- */

/* Shown when Stripe verified everything in-app (no hosted step needed). */

.BecomeACompany-successCard-YX9_s {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 22px;
  border: 1px solid #bbf7d0;
  border-radius: 16px;
  background: #f0fdf4;
  margin-bottom: 18px;
}

.BecomeACompany-successCard-YX9_s .BecomeACompany-connectIc-rzNXP {
  color: var(--green);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.BecomeACompany-successCard-YX9_s svg { width: 26px; height: 26px; }

/* Hosted-onboarding FALLBACK: a clearly-labelled SECONDARY action (never an
   automatic full-page redirect) for the rare items Stripe still needs. */

.BecomeACompany-fallbackCard-Z8WlG {
  padding: 18px 20px;
  border: 1.5px solid #f3c9cb;
  border-radius: 14px;
  background: #fff5f5;
  margin: 6px 0 18px;
}

.BecomeACompany-fallbackText-szs3q {
  margin: 0 0 10px;
  font-size: 13.5px;
  color: var(--ink);
  line-height: 1.5;
}

.BecomeACompany-fallbackLink-qmvEr {
  display: inline-block;
  font-size: 14px;
  font-weight: 800;
  color: var(--red-d);
  text-decoration: none;
  border-bottom: 2px solid var(--red);
  padding-bottom: 1px;
}

.BecomeACompany-fallbackLink-qmvEr:hover { color: var(--red); }
`, "",{"version":3,"sources":["webpack://./src/routes/become-a-company/BecomeACompany.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;;AACT;EACE;qEACmE;EACnE,oBAAoB;EACpB,kBAAkB;AACpB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,2BAAM,iBAAiB,EAAE;;AACzB;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,SAAS;;AACT;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,QAAQ;AACV;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;AACA,gCAAW,iBAAiB,EAAE;;AAC9B;EACE,wBAAwB;EACxB,iBAAiB;EACjB,qCAA6B;UAA7B,6BAA6B;AAC/B;;AACA,8BAAS,iBAAiB,EAAE;;AAC5B;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;AACb;;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mCAAmC;;AACnC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;AACpB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAS;AACX;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qEAA6D;EAA7D,6DAA6D;AAC/D;;AACA,sCAAiB,qBAAqB,EAAE;;AACxC;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA,gCAAW,iBAAiB,EAAE;;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA,8DAAoB,sBAAsB,EAAE,WAAW,EAAE;;AACzD,4DAAkB,wBAAwB,EAAE,WAAW,EAAE;;AACzD,iCAAY,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;;AAE5B,UAAU;;AACV;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,SAAS;;AACT;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AACA,8BAAS,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE;;AAChD,kCAAa,mBAAmB,EAAE,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE;;AACzE;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AACA;EACE,WAAW;EACX,8BAAsB;UAAtB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gEAAgD;EAAhD,wDAAgD;EAAhD,gDAAgD;EAAhD,0EAAgD;AAClD;;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,qCAA6B;UAA7B,6BAA6B;AAC/B;;AAEA,eAAe;;AACf;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;;AACV;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AACA;;EAEE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6BAAqB;EAArB,qBAAqB;AACvB;;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AACA;qCACgB,qBAAqB,EAAE;;AACvC;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;;AAEA,aAAa;;AACb;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AACA,8BAAS,mBAAmB,EAAE,cAAc,EAAE;;AAE9C,iBAAiB;;AACjB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA,sCAAiB,WAAW,EAAE,YAAY,EAAE;;AAC5C,uCAAkB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AACtE,sCAAiB,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEpF,WAAW;;AACX;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AACA,qCAAgB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AACrE;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AACA,8BAAS,mBAAmB,EAAE,gBAAgB,EAAE;;AAChD,8BAAS,SAAS,EAAE,iBAAiB,EAAE;;AAEvC,YAAY;;AACZ;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uFAA+D;EAA/D,+EAA+D;EAA/D,+DAA+D;EAA/D,kHAA+D;AACjE;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,uDAA+C;UAA/C,+CAA+C;AACjD;;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sCAA8B;EAA9B,8BAA8B;AAChC;;AACA,sDAAiC,wBAAwB,EAAE,iBAAiB,EAAE;;AAC9E;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;;AACb;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,gBAAgB;AAClB;;AACA,wCAAmB,WAAW,EAAE,YAAY,EAAE;;AAC9C,gCAAW,WAAW,EAAE,YAAY,EAAE,oBAAiB,EAAjB,iBAAiB,EAAE;;AACzD,uCAAkB,mBAAe,EAAf,mBAAe,EAAf,eAAe,EAAE,gBAAgB,EAAE;;AAErD,qBAAqB;;AACrB,+BAAU,kBAAkB,EAAE;;AAC9B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AACA,oCAAe,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AACrE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AACA,mCAAc,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACvF;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,8BAAsB;UAAtB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,wDAAgD;EAAhD,gDAAgD;AAClD;;AACA,yCAAoB,qBAAqB,EAAE,mBAAmB,EAAE;;AAChE,uCAAkB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;;AAChF;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AACA,2CAAsB,mBAAmB,EAAE;;AAC3C,4EAAkC,cAAc,EAAE;;AAClD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wDAAgD;EAAhD,gDAAgD;AAClD;;AACA,uCAAkB,qBAAqB,EAAE;;AACzC,mCAAc,wBAAwB,EAAE,mBAAmB,EAAE;;AAC7D;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AACA,kCAAa,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AACrE,iCAAY,iBAAiB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAEvE,gDAAgD;;AAChD,sCAAiB,gBAAgB,EAAE;;AACnC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAY,0BAA0B,EAAE;AAC1C;;AAEA;EACE,+BAAU,0BAA0B,EAAE;EACtC;IACE,8BAAmB;IAAnB,6BAAmB;QAAnB,uBAAmB;YAAnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;EACA,gCAAW,mBAAmB,EAAE;AAClC;;AACA;EACE,iCAAY,0BAA0B,EAAE;EACxC,2BAAM,gCAAgC,EAAE;EACxC,8BAAS,kBAAkB,EAAE;EAC7B,+BAAU,aAAa,EAAE;AAC3B;;AAEA,qEAAqE;;AAErE,0EAA0E;;AAC1E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AACA;EACE,mBAAmB;EACnB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA,wCAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C;yEACyE;;AACzE;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,mBAAmB;AACrB;;AACA,2CAAsB,iBAAiB,EAAE","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --green: #16a34a;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* HERO */\n.hero {\n  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),\n    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;\n  padding: 56px 0 36px;\n  text-align: center;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 14px;\n}\n.h1 {\n  font-size: clamp(30px, 5vw, 48px);\n  line-height: 1.06;\n  font-weight: 800;\n  margin: 0 auto 14px;\n  max-width: 720px;\n}\n.hl { color: var(--red); }\n.sub {\n  font-size: clamp(15px, 2.2vw, 18px);\n  color: var(--muted);\n  max-width: 620px;\n  margin: 0 auto;\n  line-height: 1.55;\n}\n\n/* BODY */\n.body {\n  padding: 8px 0 72px;\n  background: #fff;\n}\n.loading {\n  padding: 64px 0;\n  text-align: center;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n/* STATUS TRACKER */\n.tracker {\n  margin: 0 0 28px;\n  padding: 18px 22px;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: var(--bg);\n}\n.trackerInner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n.tNode {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  color: var(--muted);\n  font-weight: 700;\n  font-size: 14px;\n  white-space: nowrap;\n}\n.tDot {\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background: #fff;\n  border: 2px solid var(--line);\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  flex: 0 0 auto;\n}\n.tBar {\n  flex: 1 1 auto;\n  height: 2px;\n  background: var(--line);\n  margin: 0 4px;\n}\n.tActive { color: var(--ink); }\n.tActive .tDot {\n  border-color: var(--red);\n  color: var(--red);\n  box-shadow: 0 0 0 4px #fde7e8;\n}\n.tDone { color: var(--ink); }\n.tDone .tDot {\n  background: var(--green);\n  border-color: var(--green);\n  color: #fff;\n}\n.tReject {\n  margin-top: 14px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: #fde7e8;\n  color: var(--red-d);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* LAYOUT — left step nav + panel */\n.layout {\n  display: grid;\n  grid-template-columns: 232px 1fr;\n  gap: 28px;\n  align-items: start;\n}\n.nav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  position: sticky;\n  top: 20px;\n}\n.navItem {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-align: left;\n  padding: 13px 14px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--muted);\n  transition: border-color 0.16s, color 0.16s, background 0.16s;\n}\n.navItem:hover { border-color: #f3c9cb; }\n.navActive {\n  border-color: var(--red);\n  color: var(--ink);\n  background: #fff5f5;\n}\n.navDone { color: var(--ink); }\n.navNo {\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background: var(--bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 800;\n  flex: 0 0 auto;\n}\n.navActive .navNo { background: var(--red); color: #fff; }\n.navDone .navNo { background: var(--green); color: #fff; }\n.navLabel { flex: 1 1 auto; }\n\n/* PANEL */\n.panel {\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 30px 32px;\n  background: #fff;\n  box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);\n}\n.stepTitle {\n  font-size: 24px;\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.stepHint {\n  font-size: 15px;\n  color: var(--muted);\n  line-height: 1.55;\n  margin: 0 0 22px;\n}\n\n/* ALERTS */\n.alertErr {\n  padding: 11px 14px;\n  border-radius: 10px;\n  background: #fde7e8;\n  color: var(--red-d);\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n.alertOk {\n  padding: 11px 14px;\n  border-radius: 10px;\n  background: #e7f6ec;\n  color: #137a37;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n/* FORM */\n.formGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 6px;\n}\n.field { display: flex; flex-direction: column; }\n.fieldFull { grid-column: 1 / -1; display: flex; flex-direction: column; }\n.field > span,\n.fieldFull > span {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ink);\n  margin-bottom: 6px;\n}\n.input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 11px 13px;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 15px;\n  color: var(--ink);\n  background: #fff;\n  transition: border-color 0.16s, box-shadow 0.16s;\n}\n.input:focus {\n  outline: none;\n  border-color: var(--red);\n  box-shadow: 0 0 0 3px #fde7e8;\n}\n\n/* SUB-BLOCKS */\n.subBlock {\n  margin: 26px 0 8px;\n  padding-top: 22px;\n  border-top: 1px solid var(--line);\n}\n.subTitle {\n  font-size: 17px;\n  font-weight: 800;\n  margin: 0 0 14px;\n}\n.empty {\n  font-size: 14px;\n  color: var(--muted);\n  margin: 0 0 12px;\n}\n\n/* CHIPS */\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n  margin-bottom: 8px;\n}\n.chip,\n.chipSm {\n  padding: 9px 15px;\n  border: 1px solid var(--line);\n  border-radius: 999px;\n  background: #fff;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--muted);\n  cursor: pointer;\n  transition: all 0.14s;\n}\n.chipSm {\n  padding: 6px 11px;\n  font-size: 12.5px;\n  min-width: 42px;\n  text-align: center;\n}\n.chip:hover,\n.chipSm:hover { border-color: #f3c9cb; }\n.chipOn {\n  background: var(--red);\n  border-color: var(--red);\n  color: #fff;\n}\n\n/* DOC ROWS */\n.docRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n.tag {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #fff3d6;\n  color: #946200;\n  white-space: nowrap;\n}\n.tagOk { background: #e7f6ec; color: #137a37; }\n\n/* CONNECT CARD */\n.connectCard {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  padding: 22px;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: var(--bg);\n  margin-bottom: 18px;\n}\n.connectIc {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n.connectIc svg { width: 28px; height: 28px; }\n.connectBody h3 { margin: 0 0 4px; font-size: 17px; font-weight: 800; }\n.connectBody p { margin: 0; font-size: 14px; color: var(--muted); line-height: 1.5; }\n\n/* REVIEW */\n.review {\n  display: grid;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n.reviewSec {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 18px 20px;\n}\n.reviewSec h3 { margin: 0 0 12px; font-size: 16px; font-weight: 800; }\n.dl {\n  display: grid;\n  grid-template-columns: 130px 1fr;\n  gap: 8px 16px;\n  margin: 0;\n  font-size: 14px;\n}\n.dl dt { color: var(--muted); font-weight: 700; }\n.dl dd { margin: 0; color: var(--ink); }\n\n/* ACTIONS */\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 26px;\n  padding-top: 22px;\n  border-top: 1px solid var(--line);\n  flex-wrap: wrap;\n}\n.btn {\n  appearance: none;\n  border: none;\n  background: var(--red);\n  color: #fff;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 800;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.16s, transform 0.16s, box-shadow 0.16s;\n}\n.btn:hover:not(:disabled) {\n  background: var(--red-d);\n  transform: translateY(-1px);\n  box-shadow: 0 12px 26px rgba(232, 35, 43, 0.25);\n}\n.btnGhost {\n  appearance: none;\n  background: #fff;\n  border: 1px solid var(--line);\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 800;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: border-color 0.16s;\n}\n.btnGhost:hover:not(:disabled) { border-color: var(--red); color: var(--red); }\n.btnText {\n  appearance: none;\n  background: transparent;\n  border: none;\n  color: var(--muted);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 8px;\n}\n.btn:disabled,\n.btnGhost:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* LOGO ROW */\n.logoRow {\n  display: flex;\n  gap: 18px;\n  align-items: stretch;\n  margin: 6px 0 22px;\n  flex-wrap: wrap;\n}\n.logoPreview {\n  width: 96px;\n  height: 96px;\n  border-radius: 18px;\n  border: 1px solid var(--line);\n  background: var(--bg);\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  overflow: hidden;\n}\n.logoPreview svg { width: 38px; height: 38px; }\n.logoImg { width: 100%; height: 100%; object-fit: cover; }\n.logoUploadCell { flex: 1 1 260px; min-width: 240px; }\n\n/* UPLOAD DROP-ZONE */\n.upload { margin: 12px 0 4px; }\n.uploadHead {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n.uploadLabel { font-size: 13px; font-weight: 700; color: var(--ink); }\n.uploadReq {\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--red);\n  background: #fde7e8;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n.uploadHint { margin: 0 0 8px; font-size: 13px; color: var(--muted); line-height: 1.5; }\n.uploadDrop {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 14px 16px;\n  border: 1.5px dashed var(--line);\n  border-radius: 12px;\n  background: var(--bg);\n  cursor: pointer;\n  transition: border-color 0.16s, background 0.16s;\n}\n.uploadDrop:hover { border-color: #f3c9cb; background: #fff5f5; }\n.uploadDrop svg { width: 22px; height: 22px; color: var(--red); flex: 0 0 auto; }\n.uploadDropText {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.uploadDropDone {\n  border-style: solid;\n  border-color: var(--green);\n  background: #e7f6ec;\n}\n.uploadDropDone svg { color: var(--green); }\n.uploadDropDone .uploadDropText { color: #137a37; }\n.uploadInput {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n.uploadOk {\n  display: inline-block;\n  margin-top: 7px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #137a37;\n}\n.uploadErr {\n  display: inline-block;\n  margin-top: 7px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--red-d);\n}\n\n/* SERVICE-AREA MODE CARDS */\n.modeGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n.modeCard {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  gap: 4px;\n  padding: 16px;\n  border: 1.5px solid var(--line);\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  transition: border-color 0.16s, background 0.16s;\n}\n.modeCard:hover { border-color: #f3c9cb; }\n.modeCardOn { border-color: var(--red); background: #fff5f5; }\n.modeRadio {\n  color: var(--red);\n  font-size: 14px;\n  line-height: 1;\n  height: 14px;\n  margin-bottom: 2px;\n}\n.modeTitle { font-size: 14.5px; font-weight: 800; color: var(--ink); }\n.modeDesc { font-size: 12.5px; color: var(--muted); line-height: 1.45; }\n\n/* TIGHTER SUB-BLOCK (no top border / divider) */\n.subBlockTight { margin-top: 16px; }\n.miniLabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ink);\n  margin-bottom: 8px;\n}\n\n@media (max-width: 620px) {\n  .modeGrid { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 860px) {\n  .layout { grid-template-columns: 1fr; }\n  .nav {\n    flex-direction: row;\n    overflow-x: auto;\n    position: static;\n  }\n  .navItem { white-space: nowrap; }\n}\n@media (max-width: 620px) {\n  .formGrid { grid-template-columns: 1fr; }\n  .dl { grid-template-columns: 110px 1fr; }\n  .panel { padding: 22px 18px; }\n  .tLabel { display: none; }\n}\n\n/* ---- In-app HYBRID payout: success + hosted-fallback states ---- */\n\n/* Shown when Stripe verified everything in-app (no hosted step needed). */\n.successCard {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  padding: 22px;\n  border: 1px solid #bbf7d0;\n  border-radius: 16px;\n  background: #f0fdf4;\n  margin-bottom: 18px;\n}\n.successCard .connectIc {\n  color: var(--green);\n  flex: 0 0 auto;\n}\n.successCard svg { width: 26px; height: 26px; }\n\n/* Hosted-onboarding FALLBACK: a clearly-labelled SECONDARY action (never an\n   automatic full-page redirect) for the rare items Stripe still needs. */\n.fallbackCard {\n  padding: 18px 20px;\n  border: 1.5px solid #f3c9cb;\n  border-radius: 14px;\n  background: #fff5f5;\n  margin: 6px 0 18px;\n}\n.fallbackText {\n  margin: 0 0 10px;\n  font-size: 13.5px;\n  color: var(--ink);\n  line-height: 1.5;\n}\n.fallbackLink {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--red-d);\n  text-decoration: none;\n  border-bottom: 2px solid var(--red);\n  padding-bottom: 1px;\n}\n.fallbackLink:hover { color: var(--red); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `BecomeACompany-page-ujGUK`,
	"wrap": `BecomeACompany-wrap-gdxli`,
	"hero": `BecomeACompany-hero-UvP86`,
	"eyebrow": `BecomeACompany-eyebrow-LhNbC`,
	"h1": `BecomeACompany-h1-Y8qtU`,
	"hl": `BecomeACompany-hl-vMVk8`,
	"sub": `BecomeACompany-sub-N1X4P`,
	"body": `BecomeACompany-body-kG_YE`,
	"loading": `BecomeACompany-loading-KGFxz`,
	"tracker": `BecomeACompany-tracker-Pcccj`,
	"trackerInner": `BecomeACompany-trackerInner-GkQ3P`,
	"tNode": `BecomeACompany-tNode-_bZeu`,
	"tDot": `BecomeACompany-tDot-ZJcNt`,
	"tBar": `BecomeACompany-tBar-ZLa1O`,
	"tActive": `BecomeACompany-tActive-QZtHW`,
	"tDone": `BecomeACompany-tDone-Zf2mT`,
	"tReject": `BecomeACompany-tReject-wscBy`,
	"layout": `BecomeACompany-layout-gW78q`,
	"nav": `BecomeACompany-nav-WLMTI`,
	"navItem": `BecomeACompany-navItem-D66HW`,
	"navActive": `BecomeACompany-navActive-R99DQ`,
	"navDone": `BecomeACompany-navDone-hSQaI`,
	"navNo": `BecomeACompany-navNo-Y0Kgu`,
	"navLabel": `BecomeACompany-navLabel-MIkQS`,
	"panel": `BecomeACompany-panel-SsBFD`,
	"stepTitle": `BecomeACompany-stepTitle-jElV5`,
	"stepHint": `BecomeACompany-stepHint-gGMZg`,
	"alertErr": `BecomeACompany-alertErr-MAZlS`,
	"alertOk": `BecomeACompany-alertOk-rKEvF`,
	"formGrid": `BecomeACompany-formGrid-IVMwV`,
	"field": `BecomeACompany-field-n77dm`,
	"fieldFull": `BecomeACompany-fieldFull-lV3w8`,
	"input": `BecomeACompany-input-KhdGO`,
	"subBlock": `BecomeACompany-subBlock-EdUxN`,
	"subTitle": `BecomeACompany-subTitle-K41mr`,
	"empty": `BecomeACompany-empty-mEKda`,
	"chips": `BecomeACompany-chips-jVEAi`,
	"chip": `BecomeACompany-chip-mZO_P`,
	"chipSm": `BecomeACompany-chipSm-sMHii`,
	"chipOn": `BecomeACompany-chipOn-OHYHW`,
	"docRow": `BecomeACompany-docRow-Ovkuv`,
	"tag": `BecomeACompany-tag-dKCfI`,
	"tagOk": `BecomeACompany-tagOk-GqaUi`,
	"connectCard": `BecomeACompany-connectCard-ChkPr`,
	"connectIc": `BecomeACompany-connectIc-rzNXP`,
	"connectBody": `BecomeACompany-connectBody-u1Rxy`,
	"review": `BecomeACompany-review-FPOvH`,
	"reviewSec": `BecomeACompany-reviewSec-g2_LR`,
	"dl": `BecomeACompany-dl-Yi1r4`,
	"actions": `BecomeACompany-actions-en6vc`,
	"btn": `BecomeACompany-btn-AY5EW`,
	"btnGhost": `BecomeACompany-btnGhost-zQGzl`,
	"btnText": `BecomeACompany-btnText-CpvwE`,
	"logoRow": `BecomeACompany-logoRow-kyA5j`,
	"logoPreview": `BecomeACompany-logoPreview-CYzJw`,
	"logoImg": `BecomeACompany-logoImg-KgNYJ`,
	"logoUploadCell": `BecomeACompany-logoUploadCell-DdqOV`,
	"upload": `BecomeACompany-upload-oGymY`,
	"uploadHead": `BecomeACompany-uploadHead-k92EJ`,
	"uploadLabel": `BecomeACompany-uploadLabel-wg0ws`,
	"uploadReq": `BecomeACompany-uploadReq-SwMGO`,
	"uploadHint": `BecomeACompany-uploadHint-jEpjP`,
	"uploadDrop": `BecomeACompany-uploadDrop-pR_Ka`,
	"uploadDropText": `BecomeACompany-uploadDropText-_GBS8`,
	"uploadDropDone": `BecomeACompany-uploadDropDone-o1IdE`,
	"uploadInput": `BecomeACompany-uploadInput-HxGp3`,
	"uploadOk": `BecomeACompany-uploadOk-NMdLo`,
	"uploadErr": `BecomeACompany-uploadErr-oFS94`,
	"modeGrid": `BecomeACompany-modeGrid-msdK_`,
	"modeCard": `BecomeACompany-modeCard-AYhYr`,
	"modeCardOn": `BecomeACompany-modeCardOn-QoP1e`,
	"modeRadio": `BecomeACompany-modeRadio-mSpEJ`,
	"modeTitle": `BecomeACompany-modeTitle-E8zla`,
	"modeDesc": `BecomeACompany-modeDesc-XHbBF`,
	"subBlockTight": `BecomeACompany-subBlockTight-tsZHp`,
	"miniLabel": `BecomeACompany-miniLabel-AdRMw`,
	"tLabel": `BecomeACompany-tLabel-UKxcO`,
	"successCard": `BecomeACompany-successCard-YX9_s`,
	"fallbackCard": `BecomeACompany-fallbackCard-Z8WlG`,
	"fallbackText": `BecomeACompany-fallbackText-szs3q`,
	"fallbackLink": `BecomeACompany-fallbackLink-qmvEr`
};
module.exports = ___CSS_LOADER_EXPORT___;
